import { type DependencyList, useEffect, useState } from 'react';
import { type Loader, LOADING } from '@/generic/loader/Loader.ts';

export const useLoader = <Content, Err extends Error>(
  asyncProvider: () => Promise<Content>,
  dependencies: DependencyList,
) => {
  const [content, setContent] = useState<Loader<Content, Err>>(LOADING);

  useEffect(() => {
    asyncProvider().then(setContent).catch(setContent);
  }, [asyncProvider, ...dependencies]);

  return content;
};
